var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalkOutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.527 3.485c.502-.015.923-.198 1.263-.55.34-.351.502-.764.486-1.238C7.26 1.223 7.074.82 6.717.482 6.361.146 5.932-.014 5.43.001c-.503.015-.924.199-1.264.55-.34.352-.51.764-.51 1.238s.186.879.559 1.215c.372.336.81.497 1.312.481zM10.253 8.492l-2.2-1.154-1.798-2.772c-.347-.41-.773-.615-1.28-.615-.346 0-.68.14-1 .423L.534 7.03c-.08.102-.134.218-.16.346l-.36 2.964v.077c0 .18.066.333.2.462.133.128.293.192.48.192.186 0 .34-.064.46-.192.12-.129.193-.27.22-.424l.28-2.54 1.683-.924-.88 7.082-1.559 3.35c-.053.153-.08.294-.08.423 0 .281.1.52.3.712.2.192.446.275.74.25.4 0 .693-.18.88-.54l1.678-3.617c0-.026.014-.07.04-.135.027-.064.054-.122.08-.173.027-.052.04-.103.04-.154l.2-1.732 1.72 5.696c.186.462.52.68 1 .655.266 0 .499-.096.699-.289.2-.192.3-.43.3-.712 0-.026-.007-.058-.02-.096-.014-.039-.02-.07-.02-.096l-2.4-7.891.28-2.579.68 1.04c.054.076.12.14.2.192l2.36 1.27c.159.051.266.077.319.077.187 0 .346-.07.48-.212.133-.14.2-.301.2-.48 0-.232-.107-.411-.32-.54z",
    transform: "translate(-363 -212) translate(351 116) translate(12 97) matrix(-1 0 0 1 11 0)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeOpacity: 0.87,
    strokeWidth: 0.769
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.175 2.06L13.175 17.334 3.875 19.231 3.875 0zM3.875 1.538L0 1.538 0 17.692 3.875 17.692M5.425 10L6.975 10",
    transform: "translate(-363 -212) translate(351 116) translate(12 97) translate(25.825 .075)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M19.094 14.088L19.094 12 22 14.773 19.094 17.547 19.094 15.458 14 15.458 14 14.088z",
    transform: "translate(-363 -212) translate(351 116) translate(12 97) matrix(-1 0 0 1 36 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkOutIcon);
export default __webpack_public_path__ + "static/media/walk_out_icon.20c33de7fc7ca1ce8b8bb82291cdad0e.svg";
export { ForwardRef as ReactComponent };